module.exports = __webpack_public_path__ + "static/media/placeholder-rectangle.e764ce7e.png";